import { render, staticRenderFns } from "./DimmableLightingDevice.vue?vue&type=template&id=e45046c6&"
import script from "./DimmableLightingDevice.vue?vue&type=script&lang=js&"
export * from "./DimmableLightingDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports